module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/preViewMedia/assets/stopBtn.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/preViewMedia/assets/stopBtn.png
// module id = 1811
// module chunks = 418